import { PERMISSIONS_ACTIONS, RESOURCE } from '@constants/permissions.constants';
import { usePermissions } from '@hooks/usePermissions';

export function useHasAccess(actions: PERMISSIONS_ACTIONS[], _resource?: RESOURCE): boolean[] {
  const { checkAccess } = usePermissions();
  return actions.map((action: PERMISSIONS_ACTIONS) => checkAccess(action, _resource));
}
